import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7a99db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-6 h-100" }
const _hoisted_2 = {
  key: 0,
  class: "flex overflow-x-scroll no-scroll"
}
const _hoisted_3 = {
  key: 1,
  class: "flex overflow-x-scroll no-scroll"
}
const _hoisted_4 = {
  key: 2,
  class: "text-gray-300"
}
const _hoisted_5 = {
  class: "mt-8",
  ref: "categoryWrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "relative"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["onScroll"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4 border-transparent" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_ServicesFilterButton = _resolveComponent("ServicesFilterButton")!
  const _component_ServiceCardContent = _resolveComponent("ServiceCardContent")!
  const _component_GenericCardShell = _resolveComponent("GenericCardShell")!
  const _component_RightArrowIcon = _resolveComponent("RightArrowIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      title: _ctx.$t('analytics.title'),
      subtitle: _ctx.$t('analytics.subtitle')
    }, null, 8, ["title", "subtitle"]),
    (!_ctx.loading && !_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ServicesFilterButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAll())),
            active: _ctx.isAllActive,
            title: 'All',
            number: '',
            loading: false
          }, null, 8, ["active"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
            return (_openBlock(), _createBlock(_component_ServicesFilterButton, {
              onClick: ($event: any) => (_ctx.toggleCat(category)),
              key: index,
              active: category.active,
              title: category.name,
              number: category.services.length,
              loading: _ctx.loading
            }, null, 8, ["onClick", "active", "title", "number", "loading"]))
          }), 128))
        ]))
      : (_ctx.loading && !_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
              return _createVNode(_component_ServicesFilterButton, {
                key: index,
                loading: _ctx.loading
              }, null, 8, ["loading"])
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_TransitionGroup, { name: "fade" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (_ctx.isVisible(category, _ctx.categories))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("h2", {
                      class: "font-display my-2 flex items-center",
                      href: category.name
                    }, _toDisplayString(category.name), 9, _hoisted_7),
                    _createElementVNode("div", {
                      class: "flex gap-4 w-[calc(100%+2.5rem)] -ml-5 md:ml-0 md:w-auto overflow-x-scroll overflow-y-hidden no-scroll relative",
                      ref_for: true,
                      ref: "category",
                      onScroll: ($event: any) => (_ctx.showOrHideArrows(index))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.services, (item, i) => {
                        return (_openBlock(), _createBlock(_component_GenericCardShell, {
                          link: {
                  name: 'analyticsDetail',
                  params: { analyticsId: item.id },
                },
                          key: i,
                          class: _normalizeClass([{
                  'col-span-1 lg:col-span-2': item.size === 2,
                }, "w-[310px] aspect-video min-w-[310px]"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ServiceCardContent, {
                              id: item.id,
                              title: item.title,
                              subtitle: item.text,
                              previewType: item.previewType,
                              previewInfos: 
                    item.previewType === 'Chart'
                      ? item.chart
                      : item.previewType === 'Kpi' || item.previewType === 'KPI'
                        ? item.kpi
                        : item.previewType === 'ChartAndKPI'
                          ? [item.chart, item.kpi]
                          : item.previewType === 'Custom'
                            ? item.customHtml
                            : {}
                  ,
                              size: item.size,
                              description: item.description
                            }, null, 8, ["id", "title", "subtitle", "previewType", "previewInfos", "size", "description"])
                          ]),
                          _: 2
                        }, 1032, ["link", "class"]))
                      }), 128))
                    ], 40, _hoisted_8),
                    _createElementVNode("div", {
                      class: "absolute w-full h-[194px] z-[10] bottom-0 hidden md:block pointer-events-none",
                      ref_for: true,
                      ref: "arrows"
                    }, [
                      _createElementVNode("div", {
                        class: "h-full w-[120px] absolute arrow-shadow-1 hidden flex-col justify-center left-0 lg:-left-6 items-start",
                        ref_for: true,
                        ref: "arrowRight"
                      }, [
                        _createElementVNode("button", {
                          class: "rounded-full p-2.5 bg-bg-2 rotate-180 w-fit pointer-events-auto",
                          onClick: ($event: any) => (_ctx.scrollCategory(index, 'right'))
                        }, [
                          _createVNode(_component_RightArrowIcon, { class: "w-5 h-5 stroke-text-prim" })
                        ], 8, _hoisted_9)
                      ], 512),
                      _createElementVNode("div", {
                        class: "h-full w-[120px] absolute arrow-shadow-2 flex flex-col justify-center right-0 lg:-right-6 items-end",
                        ref_for: true,
                        ref: "arrowLeft"
                      }, [
                        _createElementVNode("button", {
                          class: "rounded-full p-2.5 bg-bg-2 w-fit pointer-events-auto",
                          onClick: ($event: any) => (_ctx.scrollCategory(index, 'left'))
                        }, [
                          _createVNode(_component_RightArrowIcon, { class: "w-5 h-5 stroke-text-prim" })
                        ], 8, _hoisted_10)
                      ], 512)
                    ], 512),
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ], 512)
  ]))
}